{
  "name": "@shopify/theme-language-server-common",
  "version": "2.20.0",
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "author": "CP Clermont <cp.clermont@shopify.com>",
  "homepage": "https://github.com/Shopify/theme-tools/tree/main/packages/theme-language-server-common#readme",
  "repository": {
    "type": "git",
    "url": "https://github.com/Shopify/theme-tools.git",
    "directory": "packages/theme-language-server-common"
  },
  "bugs": {
    "url": "https://github.com/Shopify/theme-tools/issues"
  },
  "license": "MIT",
  "publishConfig": {
    "access": "public",
    "@shopify:registry": "https://registry.npmjs.org"
  },
  "scripts": {
    "build": "yarn build:ts",
    "build:ci": "yarn build",
    "build:ts": "tsc -b src/tsconfig.build.json",
    "dev": "tsc -b src --watch",
    "test": "vitest",
    "type-check": "tsc --noEmit -p src/tsconfig.json"
  },
  "dependencies": {
    "@shopify/liquid-html-parser": "^2.9.0",
    "@shopify/theme-check-common": "3.23.0",
    "@shopify/theme-graph": "^0.2.1",
    "@vscode/web-custom-data": "^0.4.6",
    "vscode-json-languageservice": "^5.3.10",
    "vscode-languageserver": "^8.0.2",
    "vscode-css-languageservice": "6.3.2",
    "vscode-languageserver-textdocument": "^1.0.8",
    "vscode-uri": "^3.0.7"
  }
}
